import cn from 'classnames/bind';
import React, { FunctionComponent } from 'react';

import { PlayerControlButtonProps, PlayerControlButtonSize } from './PlayerControlButton.types';
import styles from './PlayerControlButton.module.css';

const cx = cn.bind(styles);

export const PlayerControlButton: FunctionComponent<PlayerControlButtonProps> = ({
    onClick,
    children,
    size = PlayerControlButtonSize.XL,
    ...restProps
}) => (
    <button {...restProps} className={cx('root', `root_size_${size}`)} onClick={onClick}>
        <div className={cx('control')}>{children}</div>
    </button>
);
